import { render } from "./wind.vue?vue&type=template&id=67fb4b50&scoped=true"
import script from "./wind.vue?vue&type=script&lang=js"
export * from "./wind.vue?vue&type=script&lang=js"

import "./wind.vue?vue&type=style&index=0&id=67fb4b50&scoped=true&lang=css"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fb4b50"]])

export default __exports__